// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__7Qg7f","tyre":"style_tyre__T7z1y"};